import React from 'react';
import styled, { css } from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
// utils
import { bodyFont } from '../../utils/css/fonts';
import search from '../../assets/icons/search.svg';
import clearSearch from '../../assets/icons/clearSearch.svg';
import { colorWhite } from '../../utils/css/colors';
import {useIsMobile} from '../../utils/usIsMobile';

const Search = ({
  debouncedValue,
  searchValue,
  clearSearchValue,
  handleSeachStringChange,
}) => {
  const { t } = useTranslation();
  const isMobile= useIsMobile();
  return (
    <S.Container>
      <S.SearchIcon
        src={debouncedValue ? clearSearch : search}
        alt="search"
        onClick={clearSearchValue}
      />
      <S.Input
        type="text"
        value={searchValue}
        placeholder={t('filters.freeSearch')}
        onChange={handleSeachStringChange}
      />
    </S.Container>
  );
};
const S: any = {};
S.Container = styled.div`
  position: relative;
  height: max-content;
  background: ${colorWhite};
  border: 1px solid #BBBBBB;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 200px;
  flex-direction: row-reverse;
`;

S.Input = styled.input`
  width: 100%;
  height: 31px;
  background: transparent;
  border: 0;
  font-family: ${bodyFont};
  font-size: 18px;
  padding-inline-start: 6px;
  align-self: center;

  &::placeholder {
    color: black;
    border: unset;
  }

  &:focus {
    outline: none;
  }
`;

const iconStyle = css`
padding-inline-end: 10px;
  cursor: pointer;
`;

S.SearchIcon = styled.img`
  ${iconStyle};
  
`;

S.LoaderIcon = styled.img`
  ${iconStyle};
  top: 4px;
  max-height: 2.1rem;
`;

export default Search;
